import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Observer/ObserverUsage.mdx";

import Examples from "../../Docs/Components/Observer/ObserverExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Observer"
            description="Listens to changes on an observable value and propagates changes to the underlying components."
            apiSources={["azure-devops-ui/Components/Observer/Observer.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;